import React from 'react';
import PropTypes from 'prop-types';

import { Box, Title, Type, Text } from '@nerdwallet/currency';

import CsrBoxLogo from './csr-box-logo/csr-box-logo';

import styles from './csrBox.module.less';

import CsrBoxLogoData from '../../../lib/employee-branding/csr-box-logos';

const CsrBox = ({
  title,
  copy,
  insertTitle,
  insertCopy,
  insertImage,
  insertBgColor,
  insertBgImage,
  insertColor,
}) => {
  const copyInHTML = (text) => ({ __html: text });

  const csrInsertImage = {
    backgroundImage: `url(${insertImage})`,
  };

  const csrInsertBgImage = {
    backgroundImage: `url(${insertBgImage})`,
  };

  const csrInsertBgColor = {
    backgroundColor: insertBgColor,
  };

  const csrInsertColor = {
    color: insertColor,
  };

  return (
    <div className={styles.csrBoxContainer}>
      <Box className={styles.csrBoxInner} shadow="1" borderRadius="2">
        <div className={styles.csrBoxTextContainer}>
          {title && (
            <Title className={styles.csrBoxTitle} size="small" component="h2">
              {title}
            </Title>
          )}
          {copy && (
            <Text component="div">
              <div
                className={styles.csrBoxCopy}
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={copyInHTML(copy)}
              />
            </Text>
          )}
        </div>
        <div className={styles.csrBoxInsert} style={csrInsertBgImage}>
          <div className={styles.csrBoxInsertInner}>
            <div
              style={csrInsertBgColor}
              className={styles.csrBoxInsertContent}
            >
              {insertTitle && (
                <Type
                  size="3"
                  className={styles.csrInsertTitle}
                  color={insertColor}
                  bold
                  component="h2"
                >
                  <div
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML={copyInHTML(insertTitle)}
                  />
                </Type>
              )}
              {insertCopy && (
                <div className={styles.csrBoxCopy} style={csrInsertColor}>
                  <Text>{insertCopy}</Text>
                </div>
              )}
            </div>
            <div className={styles.csrBoxInsertImage} style={csrInsertImage} />
          </div>
        </div>
        <div className={styles.csrStroke} />
        <CsrBoxLogo title="Our partners" {...CsrBoxLogoData} />
      </Box>
    </div>
  );
};

CsrBox.propTypes = {
  title: PropTypes.string,
  copy: PropTypes.string,
  insertTitle: PropTypes.string,
  insertCopy: PropTypes.string,
  insertImage: PropTypes.string,
  insertBgColor: PropTypes.string,
  insertBgImage: PropTypes.string,
  insertColor: PropTypes.string,
};

CsrBox.displayName = 'CSR Box';

export default CsrBox;
